export const isIOS = (): boolean => {
  const ua = navigator.userAgent || (navigator as any).vendor || (window as any).opera;
  const iPadOS = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
  return /iPhone|iPad|iPod/i.test(ua) || iPadOS;
};

export const isAndroid = (): boolean => {
  return /Android/i.test(navigator.userAgent);
};

export const isAndroidChome = (): boolean => {
  const ua = navigator.userAgent.toLocaleLowerCase();
  return isAndroid() && ['chrome', 'chromium'].some((c) => ua.includes(c));
};

export const platform = (): string => {
  const ua = navigator.userAgent || navigator.vendor;
  const isAndroid = /android/i.test(ua);
  const isApple = /iPad|iPhone|iPod/.test(ua) && !(window as any).MSStream;
  return isAndroid ? 'android' : isApple ? 'apple' : 'unsupported';
};
